"use client";

import { cn } from "../../lib/utils";
import { iconsMap } from "../icons";
import PricingFeeData from "./PricingFeeData";
import type { PricingType } from "./pricingSection.types";
import type { AdaptedFee } from "@/helpers/pricing/adapters/adaptToFee";
import { pricingVariants } from "../../helpers/pricing/pricingVariants";
import { ArrowDown } from "../icons/arrow-down";

export default function PricingCard({
  data,
  fees,
  guideAnchorId,
}: {
  data: PricingType;
  fees: AdaptedFee[];
  guideAnchorId?: string;
}) {
  const { product, icon, subheading, features, theme } = data;
  const handleGuideClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!guideAnchorId) return;
    event.preventDefault();
    const target = document.getElementById(guideAnchorId);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      window.history.pushState(null, "", `#${guideAnchorId}`);
      return;
    }
    window.location.hash = guideAnchorId;
  };
  return (
    <div className="flex flex-col p-8 bg-white rounded-xl gap-4 lg:gap-10 border border-[#03021333] font-inter">
      <div className="flex flex-row gap-4 lg:gap-6 items-center">
        <div
          className={cn(
            pricingVariants({ theme }),
            "w-12 aspect-square rounded-xl flex items-center justify-center text-xl text-white"
          )}
        >
          {iconsMap[icon]}{" "}
        </div>
        <div className="flex flex-col">
          <h3 className="font-inter text-lg">{product}</h3>
          <p>{subheading}</p>
        </div>
      </div>
      <div>
        <div className="flex flex-row items-center gap-4">
          <div className={cn(pricingVariants({ theme }), "w-3 aspect-square rounded-full")} />
          <h4>Service Fees</h4>
        </div>
        <PricingFeeData fees={fees} theme={theme} />
      </div>

      <div className="flex flex-col gap-3 ">
        <div
          className={cn(
            pricingVariants({ text: theme }),
            "flex flex-row items-center text-xl gap-2"
          )}
        >
          {iconsMap["check"]}
          <h3>What&apos;s Included</h3>
        </div>

        <ul className="flex flex-col gap-8 my-8">
          {features.map((feature) => (
            <li className="flex flex-row gap-2" key={feature._key}>
              <span className={cn(pricingVariants({ text: theme }), "text-2xl")}>
                {iconsMap[feature.icon || "check"]}
              </span>
              <span className="text-[#717182]">{feature.name}</span>
            </li>
          ))}
        </ul>
      </div>
      {guideAnchorId && (
        <a
          href={`#${guideAnchorId}`}
          onClick={handleGuideClick}
          className={cn(
            pricingVariants({ text: theme }),
            "sm:hidden mt-auto inline-flex items-center gap-2 text-base underline underline-offset-4"
          )}
        >
          <ArrowDown className="h-4 w-4 text-current" />
          <span>See what&apos;s included</span>
        </a>
      )}
    </div>
  );
}
